<template>
  <el-main>

   

<el-row :gutter="24">
  <el-col :span="12">

     <div>
      <el-divider content-position="left">新增服务器信息</el-divider>    
    </div>
  
    <el-row :gutter="20">
        <el-col :span="6">  
                   <el-input v-model="add_svr_name" placeholder="请输入服务器名称"></el-input>            
        </el-col>
        <el-col :span="6">  
                  <el-input v-model="add_svr_yuming" placeholder="请输入服务器域名"></el-input>           
        </el-col>

        <el-col :span="6">         
              <el-button @click="handleAddNewServer"   type="primary" icon="el-icon-edit">增加</el-button>          
        </el-col>
     </el-row> 

     <el-divider content-position="left">服务器列表</el-divider>
    <el-table
          ref="singleTable"
          :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}"
          :data="scannerList"
          border
          stripe         
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">


          <el-table-column
        
            label="服务器名称"
            >
           <template slot-scope="scope">
             <i class="el-icon-s-operation"></i>
            
            <span>{{ scope.row.svr_name }}</span>
          </template>

          </el-table-column>    

          <el-table-column
        
            label="服务器域名"
            >
           <template slot-scope="scope">
           
            <span >{{ scope.row.svr_yuming}}</span>
          </template>

          </el-table-column>  
                            
         <el-table-column label="选取科目"
           >
              <template slot-scope="scope">
              
              <el-button 
                  size="mini"
                  type="text"
                  @click="selServer(scope.$index, scope.row)">选取科目</el-button>
          
              </template>
          </el-table-column>   

         <el-table-column label="删除"
           >
              <template slot-scope="scope">
              
              <el-button 
                  size="mini"
                  type="text"
                  @click="delServer(scope.$index, scope.row)">删除</el-button>
          
              </template>
          </el-table-column>
    </el-table>

     <div>
      <el-divider content-position="left">选取科目   {{ sel_svr }}{{ sel_xm }}{{ sel_sb }}</el-divider>    
     </div>
     <el-cascader-panel :options="options" ref="cascaderTizu" @change="handleTizuChange"  @expand-change="cascaderChange" v-model="cascagerdefault" ></el-cascader-panel>
 	 
  </el-col>
  <el-col :span="12">
    
                 <div>
                    <el-divider content-position="left">选取科目详情--{{  tableData.length }}个</el-divider>    
                 </div>

                <el-row   :gutter="24" > 
                  
                  <el-table
                  ref="singleTable"
                  :row-style="{height:'20px'}"
                  :cell-style="{padding:'0px'}"
                  :data="tableData"
                  border
                  stripe         
                  highlight-current-row
                  @current-change="handleCurrentChange"
                  style="width: 100%"
                  >
                  <el-table-column
                 
                    prop="svr_name"
                    label="服务器"
                     >
                  </el-table-column>
                  <el-table-column
                    prop="svr_xm"
                    label="项目"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="svr_sb"
                    label="科目"
                    >
                  </el-table-column>
                  
                  <el-table-column                   
                    label="操作"
                    >
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="deleteRow(scope.$index, tableData)"
                        type="text"
                        size="small">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                </el-row> 
                <br>
                <el-row   :gutter="24" > 
                  
                  <el-checkbox v-model="innamelist" label="按系统存在名单" border size="medium"></el-checkbox>
                  <el-checkbox v-model="notincludezero" label="0分单科成绩不赋分" border size="medium"></el-checkbox>
                  <br>
                  <br>
                  <el-button @click="fufen()"  v-if="tableData.length>0" :loading="loading"  type="primary" >赋分</el-button>

                </el-row>    

       
                
  </el-col>

</el-row>


  <el-dialog title="原始分--赋分统计" :visible.sync="dialogTableVisible" :close-on-press-escape="false" :close-on-click-modal="false">
    考生数:{{studentcount}}
    <el-table 
       stripe
       border
       :default-sort = "{prop: 'yuanshi', order: 'descending'}"

      :row-style="{height:'20px'}"
      :cell-style="{padding:'0px'}"
      :data="duizhaoData">
        <el-table-column sortable property="yuanshi" label="原始分" ></el-table-column>
        <el-table-column property="fufen" label="赋分" ></el-table-column>      
    </el-table>
  </el-dialog>

   

  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          scannerList: [],
          singleTizuData:[],
          currentRow: null,
          status:false,
          add_svr_name: '',
          add_svr_yuming: '',
          title:'hello world',
          schoolList:[],
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
            sel_svr:'',
            sel_svr_yuming:'',
            sel_xm:'',
            sel_sb:'',
            dialogTableVisible: false,
            is_disable:true,
            is_jindu_disable:true,
            options:[],
            cascagerdefault: ["0", "0"],
            tableData: [],
            loading: false,
            duizhaoData:[],
            studentcount:0,
            innamelist:false,
            notincludezero:false,
         
            
         };
  },
   activated() {
			console.log('获取服务器列表');

      this.scannerList=[];
      this.handleDankeJinDu();

	},
  updated () {
　　this.$nextTick(() => {
　　　　this.$refs['singleTable'].doLayout();
　　})
  },
  methods: {


    handleDankeJinDu()
    {	
        axios.get('/scoreman?op=schoolmansvrlist').then((res)=>{
              console.log(res)
              this.scannerList=res.data['server']
              console.log(res.data['server'])
              
          }).catch((res)=>{
              console.log(response)
          })      

    },
     
        handleAddNewServer () {              
         

              axios.post('/scoreman?op=addNewServer',qs.stringify({"svr_name":this.add_svr_name,"svr_yuming":this.add_svr_yuming})).then((res)=>{
                    console.log(res.data);                   
                  
                    if (res.data=='ok')    
                    {
                       this.$alert('新增成功', '提示', {
                          confirmButtonText: '确定'
                        });
                         this.scannerList=[];
                         this.handleDankeJinDu();
                    }   
                    
                }).catch((res)=>{
                    console.log(response)
                })


        },

       delServer(index, row) {

         let scannerId=this.scannerList[index]['s_id'];
        
        axios.post('/scoreman?op=delServer',qs.stringify({"id":scannerId})).then((res)=>{
                    console.log(res.data);               
                  
                    if (res.data=='ok')    
                    {
                      this.$alert('删除成功', '提示', {
                          confirmButtonText: '确定'
                        });
                         this.scannerList=[];
                         this.handleDankeJinDu();
                    }   
                    
                }).catch((res)=>{
                    console.log(response)
                })
  
      },

        selServer(index, row) {

         let scannerId=this.scannerList[index]['s_id'];
         let sel_svr_name=this.scannerList[index]['svr_name'];
         let sel_svr_yuming=this.scannerList[index]['svr_yuming'];

         this.sel_svr=sel_svr_name;
         this.sel_svr_yuming=sel_svr_yuming;

         this.sel_xm='';
				 this.sel_sb='';	

        
        axios.post('/scoreman?op=selServerXm',qs.stringify({"svr_yuming":sel_svr_yuming})).then((res)=>{
                    console.log(res.data); 
                    this.options=res.data;              
                  
                    if (res.data=='ok')    
                    {
                      this.$alert('删除成功', '提示', {
                          confirmButtonText: '确定'
                        });
                       //  this.options=[];
                        
                    }   
                    
                }).catch((res)=>{
                    console.log(response)
                })
  
      },

       fufen() {
                  
        this.loading=true;
        let jsonstr=JSON.stringify(this.tableData);
        let innamelist='no';
        if (this.innamelist==true)
        {
            innamelist='yes';
        }

        let notincludezero='no';
        if (this.notincludezero==true)
        {
          notincludezero='yes';
        }
       
        axios.post('/scoreman?op=fufen',qs.stringify({"svr_list":jsonstr,'innamelist':innamelist,'notincludezero':notincludezero})).then((res)=>{
                    console.log(res.data);                              
                  
                    if (res.data['msg']=='processfufenok')    
                    {             
                       this.studentcount=res.data['studentcount'];         
                       this.duizhaoData=res.data['duizhaobiao'];
                       this.dialogTableVisible = true; 
                    }   

                    this.loading=false;
                    
                }).catch((res)=>{
                    this.loading=false;
                });                
  
      },

      handleTizuChange(val){
				console.log(val)
				this.$refs['cascaderTizu'].getCheckedNodes()[0].pathLabels
				console.log(this.$refs['cascaderTizu'].getCheckedNodes()[0].pathLabels)
				this.sel_xm=val[0];
				this.sel_sb=val[1];		
        
        if (val.length==2)
        {
         // this.tableData=this.tableData.push({'svr_name':4},{'svr_xm':4},{'svr_sb':4});
            console.log('handleTizuChange_start')
            let newArr = [];
            for (var i = 0; i <this.tableData.length; i++) {
              let onerecord = {};
              onerecord.svr_name = this.tableData[i].svr_name;
              onerecord.svr_yuming = this.tableData[i].svr_yuming;
              onerecord.svr_xm = this.tableData[i].svr_xm;
              onerecord.svr_sb = this.tableData[i].svr_sb;
              newArr.push(onerecord);
              }

             
            let  onerecord = {};
            onerecord.svr_name=this.sel_svr;
            onerecord.svr_yuming = this.sel_svr_yuming
            onerecord.svr_xm=this.sel_xm;
            onerecord.svr_sb=this.sel_sb;

            newArr.push(onerecord);

            
            
            this.tableData=newArr;
            console.log('handleTizuChange_end')

        }

			},

    cascaderChange(val) {
			console.log(val)
		

			if (val.length==2&&val.length!=3)
			{
				this.is_jindu_disable=false;
				this.sel_xm=val[0];
				this.sel_sb=val[1];

        
			}
			else
			{
				this.sel_xm='';
				this.sel_sb='';
			}

			
		},

    deleteRow(index, rows) {
        rows.splice(index, 1);
      }


  },
}
</script>

<style scoped>
.el-dialog {
     display: flex;
     flex-direction: column;
     margin:0 !important;
     position:absolute;
     top:50%;
     left:50%;
     transform:translate(-50%,-50%);
     /*height:600px;*/
     max-height:calc(100% - 200px);
     max-width:calc(100% - 30px);
}
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
  }
.el-dialog .el-dialog__body {
     flex:1;
     overflow: auto;
}


</style>